export const dashboardMessages = {
  // student dashboard

  milestoneFlowSectionTitle: {
    key: "dashboard.labelsAndTitles.VENTURE_JOURNEY",
  },
  setUpAppoinments: {
    key: "dashboard.labelsAndTitles.SETUP_APPOINMENTS"
  },
  setUpDesc: {
    key: "dashboard.labelsAndTitles.SETUP_APPOINMENTS_DESC"
  },
  instructionSectionLine1: {
    key: "dashboard.labelsAndTitles.INSTRUCTION_SECTION_LINE1",
  },

  instructionSectionLine2: {
    key: "dashboard.labelsAndTitles.INSTRUCTION_SECTION_LINE2",
  },
  connectZoom: {
    key: "dashboard.labelsAndTitles.CONNECT_ZOOM"
  },
  connectZoomDesc: {
    key: "dashboard.labelsAndTitles.CONNECT_ZOOM_DESC"
  },
  connectCalcom: {
    key: "dashboard.labelsAndTitles.CONNECT_CALCOM"
  },
  connectCalcomDesc: {
    key: "dashboard.labelsAndTitles.CONNECT_CALCOM_DESC"
  },
  setUpProfile: {
    key: "dashboard.labelsAndTitles.SETUP_PROFILE"
  },
  setUpProfileDesc: {
    key: "dashboard.labelsAndTitles.SETUP_PROFILE_DESC"
  },
  setUp: {
    key: "dashboard.labelsAndTitles.SETUP"
  },
  connect: {
    key: 'mentor.actions.CONNECT'
  },
  instructions: {
    key: "dashboard.labelsAndTitles.SUBMISSION_INSTRUCTIONS"
  },
  milestoneFlowNotStartedStatus: {
    key: "dashboard.labelsAndTitles.NOT_STARTED",
  },

  milestoneFlowEvaluatedStatusLabel: {
    key: "dashboard.labelsAndTitles.EVALUATED",
  },

  statusLabel: {
    key: "global.labelsAndTitles.STATUS",
  },

  editVentureAction: {
    key: "global.actions.EDIT"
  },

  myCourses: {
    key: "dashboard.myCourses"
  },
  myBatches: {
    key: "dashboard.myBatches"
  },
  start: {
    key: "dashboard.start"
  },
  end: {
    key: "dashboard.end"
  },
  students: {
    key: "dashboard.students"
  },
  progress: {
    key: "dashboard.progress"
  },
  trendingArticles: {
    key: "dashboard.trendingArticles"
  },
  noCoursesFound: {
    key: "dashboard.noCoursesFound"
  },
  noBatchesFound: {
    key: "dashboard.noBatchesFound"
  },
  noArticlesFound: {
    key: "dashboard.noArticlesFound"
  },
  score: {
    key: "dashboard.score"
  },
  status: {
    key: "dashboard.status"
  },
  lessonsCompleted: {
    key: "dashboard.lessonsCompleted"
  },
  submissions: {
    key: "dashboard.submissions"
  },
  viewReportbtn: {
    key: "dashboard.viewReportbtn"
  },
  reviewCourse: {
    key: "dashboard.reviewCourse"
  },
  authoredBy: {
    key: "dashboard.authoredBy"
  },
  readTime: {
    key: "dashboard.readTime"
  },
  articlesHeading: {
    key: "dashboard.articlesHeading"
  },
  articlesLoadingError: {
    key: "dashboard.articlesLoadingError"
  },
  enrollFirstCourseHeading: {
    key: "dashboard.enrollFirstCourseHeading"
  },
  enrollFirstCourseDesc: {
    key: "dashboard.enrollFirstCourseDesc"
  },
  enrollForACourseBtn: {
    key: "dashboard.enrollForACourseBtn"
  },
  enrollBatchPopupTitle: {
    key: "dashboard.enrollBatchPopupTitle"
  },
  enrollBatchPopupDesc: {
    key: "dashboard.enrollBatchPopupDesc"
  },
  provideUUIDPlaceholder: {
    key: "dashboard.provideUUIDPlaceholder"
  },
  createFirstBatchHeading: {
    key: "dashboard.createFirstBatchHeading"
  },
  createFirstBatchDesc: {
    key: "dashboard.createFirstBatchDesc"
  },
  createBatchBtn: {
    key: "dashboard.createBatchBtn"
  },
  batchJoinPopupTitle: {
    key: "dashboard.batchJoinPopup.title"
  },
  courseName: {
    key: "dashboard.batchJoinPopup.courseName"
  },
  description: {
    key: "dashboard.batchJoinPopup.description"
  },
  batchJoinPopupfaculty: {
    key: "dashboard.batchJoinPopup.faculty"
  },
  startDate: {
    key: "dashboard.batchJoinPopup.startDate"
  },
  batchName: {
    key: "dashboard.batchJoinPopup.batchName"
  },
  batchUUID: {
    key: "dashboard.batchJoinPopup.batchUUID"
  },
  confirmEnroll: {
    key: "dashboard.batchJoinPopup.confirmEnroll"
  },
  joinBatchSuccess: {
    key: "dashboard.batchJoinPopup.joinBatchSuccess"
  },
  welcome: {
    key: "dashboard.welcome"
  },
  //Welcone card
  welcomeText: {
    key: "dashboard.labelsAndTitles.WELCOMETEXT"
  },
  welcomeCardContent: {
    key: "dashboard.labelsAndTitles.WELCOME_CARD_CONTENT"
  },
  hello: {
    key: "dashboard.labelsAndTitles.HELLO"
  },
  welcomeWitpText: {
    key: 'dashboard.labelsAndTitles.WELCOME_WITP'
  },

  //batch card

  myCohortBatchCard: {
    key: "dashboard.labelsAndTitles.MY_COHORT"
  },
  myCohortContent: {
    key: "dashboard.labelsAndTitles.MY_COHORT_CONTENT"
  },
  highlightedContentStudents: {
    key: "dashboard.labelsAndTitles.STUDENTS"
  },
  highlightedContent: {
    key: "dashboard.labelsAndTitles.HIGHLIGHTED_CONTENT"
  },
  weeklyPlannerBatchCard: {
    key: "dashboard.labelsAndTitles.WEEKLY_PLANNER"
  },
  weeklyPlannerContent: {
    key: "dashboard.labelsAndTitles.WEEKLY_PLANNER_CONTENT"
  },
  myVentureBatchCard: {
    key: "dashboard.labelsAndTitles.MY_VENTURE"
  },
  myVentureContent: {
    key: "dashboard.labelsAndTitles.MY_VENTURE_CONTENT"
  },
  myVentureHighlightedContent: {
    key: "dashboard.labelsAndTitles.MY_VENTUR_HIGHLIGHTED_CONTENT"
  },

  //welcome modal
  welcomeHeading: {
    key: "dashboard.labelsAndTitles.WELCOME_MODEL_HEAD"
  },
  welcomeCardSub: {
    key: "dashboard.labelsAndTitles.WELCOME_MODEL_SUBHEAD"
  },
  dashboardTitle: {
    key: "dashboard.labelsAndTitles.DASHBOARD_TITLE"
  },
  dashboardText: {
    key: "dashboard.labelsAndTitles.DASHBORD_TEXT"
  },
  reportsText: {
    key: "dashboard.labelsAndTitles.REPORTS_TEXT"
  },
  eventText: {
    key: "dashboard.labelsAndTitles.EVENTS_TEXT"
  },
  chatText: {
    key: "dashboard.labelsAndTitles.CHAT_TEXT"
  },
  securityText: {
    key: "dashboard.labelsAndTitles.SECURITY_TEXT"
  },
  securityTitle: {
    key: "dashboard.labelsAndTitles.SECURITY_TITLE"
  },
  knowledgeText: {
    key: "dashboard.labelsAndTitles.KNOWLEDGE_TEXT"
  },
  knowledgeTitle: {
    key: "dashboard.labelsAndTitles.KNOWLEDGE_TITLE"
  },
  groupText: {
    key: "dashboard.labelsAndTitles.GROUP_TEXT"
  },
  groupTitle: {
    key: "dashboard.labelsAndTitles.GROUP_TITLE"
  },
  courseContentText: {
    key: "dashboard.labelsAndTitles.COURSE_CONTENT_TEXT"
  },
  courseContentTitle: {
    key: "dashboard.labelsAndTitles.COURSE_CONTENT_TITLE"
  },
  certificateTitle: {
    key: "dashboard.labelsAndTitles.CERTIFICATE_TITLE"
  },
  certificateText: {
    key: "dashboard.labelsAndTitles.CERTIFICATE_TEXT"
  },
  goToCourse: {
    key: "dashboard.labelsAndTitles.GO_TO_COURSE"
  },
  viewReports: {
    key: "dashboard.labelsAndTitles.VIEW_REPORTS"
  },
  calenderText: {
    key: "dashboard.labelsAndTitles.CALENDAR_TEXT"
  },

  //genrel
  enroll: {
    key: "general.enroll"
  },
  viewAll: {
    key: "general.viewAll"
  },
  cancel: {
    key: "global.CANCEL"
  },
  close: {
    key: "global.CLOSE"
  },
  enterBatchCode: {
    key: "dashboard.labelsAndTitles.PLEASE_ENTER_BATCH_CODE"
  },
  enrollNewCourse: {
    key: "dashboard.labelsAndTitles.ENROLL_NEW_COURSE"
  },
  enterCodeDescription: {
    key: "dashboard.labelsAndTitles.ENTER_CODE_DESCRIPTION"
  },
  enterCode: {
    key: "dashboard.labelsAndTitles.ENTER_CODE"
  },
  enrollNewBatch: {
    key: "dashboard.labelsAndTitles.ENROLL_NEW_BATCH"
  },
  intro: {
    key: "dashboard.labelsAndTitles.INTRO"
  },
  myScore: {
    key: "dashboard.labelsAndTitles.MY_SCORE"
  },
  timeRemaining: {
    key: "dashboard.labelsAndTitles.TIME_REMAINING"
  },
  days: {
    key: "dashboard.labelsAndTitles.DAYS"
  },
  okay: {
    key: "global.actions.OKAY"
  },
  inProgress: {
    key: "dashboard.API_COURSE_STATUS.inProgress"
  },
  notAttempted: {
    key: "cohort.labelsAndTitles.QUIZ_NOT_ATTEMPTED"
  },
  viewBatch: {
    key: "dashboard.labelsAndTitles.VIEW_BATCH"
  },
  reports: {
    key: "layout.labelsAndTitles.REPORTS_MENU"
  },
  modules: {
    key: "dashboard.labelsAndTitles.MODULES"
  },
  progressModuleLevelHeader: {
    key: "dashboard.labelsAndTitles.PROGRESS_MODULE_LEVEL_HEADER"
  },
  notStarted: {
    key: "dashboard.labelsAndTitles.NOT_STARTED"
  },
  //API errpr
  SOMETHING_WENT_WRONG: {
    key: "API_ERRORS.IAM_SERVICE.SOMETHING_WENT_WRONG"
  },
  seeMore: {
    key: "global.actions.SEE_MORE"
  },
  completed: {
    key: "dashboard.API_COURSE_STATUS.completed"
  },
  left: {
    key: "global.actions.LEFT"
  },
  started: {
    key: "global.actions.STARTED"
  },
  scoreProgress: {
    key: "dashboard.labelsAndTitles.COURSE_PROGRESS"
  },
  scorecard: {
    key: "report.labelsAndTitles.SCORECARD"
  },
  viewCourse: {
    key: "report.labelsAndTitles.VIEW_COURSE"
  },
  hereAreTheCourses: {
    key: "dashboard.labelsAndTitles.COURSES_ATTENDING"
  },
  welcomeTitle: {
    key: "global.actions.WELCOME"
  },
  noData: {
    key: "global.messages.NO_DATA"
  },
  certifiedCourses: {
    key: "courseDetails.labelsAndTitles.CERTIFIED_COURSE"
  },
  ongoing: {
    key: "global.labelsAndTitles.ONGOING"
  },
  notStartedStatus: {
    key: "report.labelsAndTitles.NOT_STARTED"
  },
  currentScore: {
    key: "dashboard.labelsAndTitles.CURRENT_SCORE"
  },
  enrolled: {
    key: "dashboard.API_COURSE_STATUS.enrolled"
  },
  courseProgress: {
    key: "dashboard.labelsAndTitles.COURSE_PROGRESS"
  },
  assessmentProgress: {
    key: "dashboard.labelsAndTitles.ASSESSMENT_PROGRESS"
  },
  congratulations: {
    key: "courseDetails.labelsAndTitles.CONGRATULATIONS"
  },
  certificateReady: {
    key: "dashboard.labelsAndTitles.CERTIFICATE_READY"
  },
  viewScorecard: {
    key: "dashboard.labelsAndTitles.VIEW_SCORECARD"
  },
  courseNotStarted: {
    key: "dashboard.labelsAndTitles.COURSE_NOT_STARTED"
  },
  coursePotential: {
    key: "dashboard.labelsAndTitles.COURSE_POTENTIAL"
  },
  startNow: {
    key: "dashboard.labelsAndTitles.START_NOW"
  },
  ongoingEmptyState: {
    key: "dashboard.labelsAndTitles.ACTIVE_EMPTY_STATE"
  },
  completedEmptyState: {
    key: "dashboard.labelsAndTitles.COMPLETED_EMPTY_STATE"
  },
  finalScore: {
    key: "courseDetails.labelsAndTitles.FINAL_SCORE"
  },
  learnInDemandSkills: {
    key: "dashboard.labelsAndTitles.LEARN_INDEMAND_SKILLS"
  },
  learnInDemandSkillsDesc: {
    key: "dashboard.labelsAndTitles.LEARN_INDEMAND_SKILLS_DESC"
  },
  joinBatchHeading: {
    key: "dashboard.labelsAndTitles.JOIN_BATCH"
  },
  joinBatchDesc: {
    key: "dashboard.labelsAndTitles.JOIN_BATCH_DESC"
  },
  showYourSkills: {
    key: "dashboard.labelsAndTitles.SHOWCASE_SKILLS"
  },
  downloadSkillScoreCard: {
    key: "dashboard.labelsAndTitles.DOWNLOAD_SKILL_SCORECARD"
  },
  completeProfileHeading: {
    key: "dashboard.labelsAndTitles.COMPLETE_PROFILE_NUDGE_HEADING"
  },
  completeProfileDescription: {
    key: "dashboard.labelsAndTitles.COMPLETE_PROFILE_NUDGE_DESCRIPTION"
  },
  completeProfileBtn: {
    key: "dashboard.labelsAndTitles.COMPLETE_PROFILE_NUDGE_BTN"
  },
  completeProfileScreenHeading: {
    key: "dashboard.labelsAndTitles.COMPLETE_PROFILE_SCREEN_HEADING"
  },
  submit: {
    key: "register.submit"
  },
  next: {
    key: "register.next"
  },
  iWillDoLater: {
    key: "dashboard.labelsAndTitles.I_WILL_DO_LATER"
  },
  basicInformation: {
    key: "dashboard.labelsAndTitles.BASIC_INFORMATION"
  },
  mobileNumberMandatory: {
    key: "dashboard.labelsAndTitles.MOBILE_NUMBER_MANDATORY"
  },
  presentStatus: {
    key: "dashboard.labelsAndTitles.PRESENT_STATUS"
  },
  areYouStudent: {
    key: "dashboard.labelsAndTitles.ARE_YOU_STUDENT"
  },
  areYouEmployed: {
    key: "dashboard.labelsAndTitles.ARE_YOU_EMPLOYED"
  },
  educationalInfo: {
    key: "dashboard.labelsAndTitles.EDUCATIONAL_INFO"
  },
  instituteName: {
    key: "dashboard.labelsAndTitles.INSTITUTE_NAME"
  },
  whatAreYouPursuing: {
    key: "dashboard.labelsAndTitles.WHAT_ARE_YOU_PURSUING"
  },
  aspiringSector: {
    key: "dashboard.labelsAndTitles.ASPIRING_SECTOR"
  },
  graduationMonthYear: {
    key: "dashboard.labelsAndTitles.GRADUATION_MONTH_YEAR"
  },
  employmentInfo: {
    key: "dashboard.labelsAndTitles.EMPLOYMENT_INFORMATION"
  },
  employerName: {
    key: "dashboard.labelsAndTitles.EMPLOYER_NAME"
  },
  employmentSector: {
    key: "dashboard.labelsAndTitles.EMPLOYMENT_SECTOR"
  },
  joiningMonthYear: {
    key: "dashboard.labelsAndTitles.JOINING_MONTH_YEAR"
  },
  yes: {
    key: "global.labelsAndTitles.YES"
  },
  no: {
    key: "global.labelsAndTitles.NO"
  },
  completeProfilModaleHeading: {
    key: "dashboard.labelsAndTitles.COMPLETE_PROFILE_NUDGE_HEADING"
  },
  completeProfileModalDescription: {
    key: "dashboard.labelsAndTitles.COMPLETE_PROFILE_MODAL_DESCRIPTION"
  },
  topics: {
    key: "dashboard.labelsAndTitles.TOPICS"
  },
  viewForum: {
    key: "dashboard.labelsAndTitles.VIEW_FORUM"
  },
  forum: {
    key: "dashboard.labelsAndTitles.FORUM"
  },
  forumTourHeading: {
    key: "dashboard.labelsAndTitles.FORUM_TOUR_HEADING"
  },
  forumTourHeadingBold: {
    key: "dashboard.labelsAndTitles.FORUM_TOUR_HEADING_BOLD"
  },
  forumTourDescription: {
    key: "dashboard.labelsAndTitles.FORUM_TOUR_DESCRIPTION"
  },
  forumTourDescriptionBold: {
    key: "dashboard.labelsAndTitles.FORUM_TOUR_DESCRIPTION_BOLD"
  },
  done: {
    key: "dashboard.labelsAndTitles.DONE"
  },
  introducingForum: {
    key: "dashboard.labelsAndTitles.INTRODUCING_FORUMS"
  },
  redirectingForumHeading: {
    key: "dashboard.labelsAndTitles.REDIRECTING_FORUM_HEADING"
  },
  redirectingForumDesc: {
    key: "dashboard.labelsAndTitles.REDIRECTING_FORUM_DESC"
  },
  updateYourPresentStatus: {
    key: "dashboard.labelsAndTitles.UPDATE_YOUR_CURRENT_STATUS"
  },
  projectedGraduationDate: {
    key: "dashboard.labelsAndTitles.PROJECTED_GRADUATION_DATE"
  },
  unlockPremiumFeatureHeading: {
    key: "dashboard.labelsAndTitles.UNLOCK_PREMIUM_FEATURE_HEADING"
  },
  unlockPremiumFeatureDescription: {
    key: "dashboard.labelsAndTitles.UNLOCK_PREMIUM_FEATURE_DESCRIPTION"
  },
  stillPursuing: {
    key: "dashboard.labelsAndTitles.STILL_PURSUING"
  },
  working: {
    key: "dashboard.labelsAndTitles.WORKING"
  },
  offerNotJoined: {
    key: "dashboard.labelsAndTitles.OFFER_NOT_JOINED"
  },
  lookingForJob: {
    key: "dashboard.labelsAndTitles.LOOKING_FOR_JOB"
  },
  selfEmployed: {
    key: "dashboard.labelsAndTitles.SELF_EMPLOYED"
  },
  fulltimeJob: {
    key: "dashboard.labelsAndTitles.FULL_TIME_JOB"
  },
  otherFreelance: {
    key: "dashboard.labelsAndTitles.OTHERS_FREELANCE"
  },
  perMonth: {
    key: "dashboard.labelsAndTitles.PER_MONTH"
  },
  perYear: {
    key: "dashboard.labelsAndTitles.PER_YEAR"
  },
  updateCurrentStatus: {
    key: "dashboard.labelsAndTitles.UPDATE_CURRENT_STATUS"
  },
  typeOfEmployment: {
    key: "dashboard.labelsAndTitles.TYPE_OF_EMPLOYMENT"
  },
  nameOfCompany: {
    key: "dashboard.labelsAndTitles.NAME_OF_COMPANY"
  },
  chooseSector: {
    key: "dashboard.labelsAndTitles.CHOOSE_SECTOR"
  },
  howManyEmployees: {
    key: "dashboard.labelsAndTitles.HOW_MANY_EMPLOYESS"
  },
  estimatedRevenue: {
    key: "dashboard.labelsAndTitles.ESTIMATED_REVENUE"
  },
  salaryDetails: {
    key: "dashboard.labelsAndTitles.SALARY_DETAILS"
  },
  uploadSupportingDoc: {
    key: "dashboard.labelsAndTitles.UPLOAD_SUPPORTING_DOC"
  },
  uploadSupportingDocDesc: {
    key: "dashboard.labelsAndTitles.UPLOAD_SUPPORTING_DOC_DESCRIPTION"
  },
  describeEmployment: {
    key: "dashboard.labelsAndTitles.DESCRIBE_EMPLOYMENT"
  },
  coursesAndPrograms: {
    key: "dashboard.labelsAndTitles.COURSES_AND_PROGRAMS"
  },
  coursesAndProgramsSubheading: {
    key: "dashboard.labelsAndTitles.COURSES_AND_PROGRAMS_SUBHEADING"
  },
  events: {
    key: "dashboard.labelsAndTitles.EVENTS"
  },
  eventsSubheading: {
    key: "dashboard.labelsAndTitles.EVENTS_SUBHEADING"
  },
  forumSubheading: {
    key: "dashboard.labelsAndTitles.FORUM_SUBHEADING"
  },
  recommendedByInstitute: {
    key: "dashboard.labelsAndTitles.RECOMMENDED_BY_INSTITUTE"
  },
  offeredByWadhwani: {
    key: "dashboard.labelsAndTitles.OFFERED_BY_WADHWANI"
  },
  continueCourse: {
    key: "dashboard.labelsAndTitles.CONTINUE_COURSE"
  },
  myLearningHistory: {
    key: "dashboard.labelsAndTitles.MY_LEARNING_HISTORY"
  },
  noOngoingCourse: {
    key: "dashboard.labelsAndTitles.NO_ONGOING_COURSE"
  },
  forumCapitalized: {
    key: "dashboard.labelsAndTitles.FORUM_CAPITALIZED"
  },
  enrolledCourseDescription: {
    key: "dashboard.labelsAndTitles.ENROLLED_COURSE_DESCRIPTION"
  },
  connectSlotBooking: {
    key: "dashboard.labelsAndTitles.CONNECT_SLOT_BOOKING"
  },
  connectSlotBookingDesc: {
    key: "dashboard.labelsAndTitles.CONNECT_SLOT_BOOKING_DESC"
  },
  joinForum: {
    key: "dashboard.labelsAndTitles.JOIN_FORUM"
  },
  trendingTopics: {
    key: "dashboard.labelsAndTitles.TRENDING_TOPICS"
  },
  exploreTrendingTopic: {
    key: "dashboard.labelsAndTitles.EXPLORE_TRENDING_TOPICS"
  },
  viewDiscussion: {
    key: "dashboard.labelsAndTitles.VIEW_DISCUSSION"
  },
  recommendedActivities: {
    key: "dashboard.labelsAndTitles.RECOMMENDED_ACTIVITIES"
  },
  viewAllActDesc: {
    key: "dashboard.labelsAndTitles.VIEW_ALL_ACTIVITIES_DEC"
  },
  viewUpdates: {
    key: "dashboard.labelsAndTitles.VIEW_UPDATES"
  },
  viewALL: {
    key: "courseDetails.labelsAndTitles.VIEW_ALL"
  },
};
